var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.41406,
    y: 3,
    width: 24,
    height: 2,
    rx: 1,
    transform: "rotate(45 4.41406 3)",
    fill: "#00A050"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 19.9707,
    width: 24,
    height: 2,
    rx: 1,
    transform: "rotate(-45 3 19.9707)",
    fill: "#00A050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGreen);
export default __webpack_public_path__ + "static/media/close-green.7c26fdb6dfd8b30dd6138f1baec32868.svg";
export { ForwardRef as ReactComponent };